import PolicyLayout from "@/components/PolicyLayout";

const sections = [
    {
        heading: "1. What cookies are",
        body: [
            "Cookies are small text files placed on your device when you visit a website. Similar technologies — such as local storage and session storage — work in comparable ways. Throughout this policy we use \"cookies\" to refer to all of these technologies.",
        ],
    },
    {
        heading: "2. Cookies and storage we use",
        body: ["nexuspeptides.online uses the following:"],
        list: [
            "Authentication cookies — httpOnly cookies named access_token and refresh_token used to keep you signed in. These are strictly necessary and cannot be disabled if you wish to use account features.",
            "Cart storage — your shopping cart contents are stored in your browser's localStorage under the key \"nexus_cart_v2\". This data never leaves your browser unless you check out.",
            "Session preferences — short-lived values used to remember things like the currently selected dose on a product page.",
        ],
    },
    {
        heading: "3. Categories",
        body: ["We classify the above as follows:"],
        list: [
            "Strictly necessary — authentication and cart storage. Without these the core site does not function.",
            "Functional — preferences and selections you make while browsing.",
            "Analytics — we do not currently use third-party analytics cookies. If this changes, we will update this policy and request your consent where required.",
        ],
    },
    {
        heading: "4. Third-party services",
        body: [
            "Payment processing, shipping, and email delivery may use their own cookies when you interact with their flows. We do not control these third-party cookies and recommend you review the privacy policies of each provider.",
        ],
    },
    {
        heading: "5. Managing cookies",
        body: [
            "You can clear cookies and local storage at any time through your browser settings. Doing so will sign you out of your account and empty your cart. Most browsers also let you block cookies entirely, although this will prevent the site from working correctly.",
        ],
    },
    {
        heading: "6. Updates",
        body: [
            "If we add new categories of cookies or change how existing ones are used, we will update this page and the \"last updated\" date above.",
        ],
    },
    {
        heading: "7. Contact",
        body: ["Questions about this policy can be sent to info@nexuspeptides.online."],
    },
];

export default function CookiePolicy() {
    return (
        <PolicyLayout
            eyebrow="// Legal"
            title="Cookie policy"
            intro="This page explains the cookies and similar storage technologies we use on nexuspeptides.online and how you can manage them."
            sections={sections}
            footer="This document is provided for general information only and does not constitute legal advice."
        />
    );
}
